export class Diagnostico {
    ENFERMEDAD: string;
    DIAGNOSTICO: string;
    EPISODIO: string;
    CCIE9: string;
    DESCRIPCION: string;
    DNI_MED: string;
    ESP_PROF: string;
    FECHA: string;
    NUM_VISITA: string;
    ACTIVO: string;
}



// WEBPACK FOOTER //
// ./src/models/diagnostico.ts